import { AxiosResponse } from "axios";

/** Maps OpenAPI list/single responses to domain DTOs while preserving Axios metadata. */
export async function mapAxiosData<TIn, TOut>(
  promise: Promise<AxiosResponse<TIn>>,
  mapper: (value: TIn) => TOut
): Promise<AxiosResponse<TOut>> {
  const response = await promise;
  return { ...response, data: mapper(response.data) };
}

export async function mapAxiosListData<TIn, TOut>(
  promise: Promise<AxiosResponse<TIn[]>>,
  mapper: (items: TIn[] | undefined) => TOut[]
): Promise<AxiosResponse<TOut[]>> {
  const response = await promise;
  const items = Array.isArray(response.data) ? response.data : [];
  return { ...response, data: mapper(items) };
}

export async function asVoidResponse(
  promise: Promise<AxiosResponse<unknown>>
): Promise<AxiosResponse<void>> {
  const response = await promise;
  return { ...response, data: undefined };
}
